import { DateTime } from "luxon";

export function buildHistoricalSnapshotTimestamp({
  selectedDate,
  minUpdatedAt,
  maxUpdatedAt,
  fallbackTime = DateTime.now()
}: {
  selectedDate?: string | null;
  minUpdatedAt: string;
  maxUpdatedAt: string;
  fallbackTime?: DateTime;
}) {
  if (!selectedDate) return null;

  const minDate = DateTime.fromISO(minUpdatedAt);
  const maxDate = DateTime.fromISO(maxUpdatedAt);
  const selectedDateTime = DateTime.fromISO(selectedDate);

  if (!minDate.isValid || !maxDate.isValid || !selectedDateTime.isValid || maxDate <= minDate) {
    throw new Error("Historical compensation profile date range is invalid.");
  }

  const lowerBound = minDate.plus({ milliseconds: 1 });
  const upperBound = maxDate.minus({ milliseconds: 1 });

  if (upperBound < lowerBound) {
    throw new Error("Historical compensation profile date range is too narrow.");
  }

  const candidateDate = selectedDateTime.set({
    hour: fallbackTime.hour,
    minute: fallbackTime.minute,
    second: fallbackTime.second,
    millisecond: fallbackTime.millisecond
  });

  if (candidateDate < lowerBound) return lowerBound.toISO();
  if (candidateDate > upperBound) return upperBound.toISO();

  return candidateDate.toISO();
}
